<template>
  <layout title="Responsible Disclosure Program">
    <textFirstSection title="Responsible Disclosure Program" />
    <div class="flex justify-center p-6">
      <div class="mt-6 html-editor max-w-6xl mb-6">
        <h5>LAST UPDATED: 22 FEBRUARY 2024</h5>

        <p>
          <strong
            >Youverse simplifies all consumer interactions with secure and
            private identity and face verification on any device in industries
            as diverse as Retail, Banking &amp; Payments, Travel &amp;
            Hospitality, Healthcare, Self-Service &amp; Delivery. Register once
            and access services anywhere, anytime by just using your face.</strong
          ><br />
        </p>
          
        <p>
          At Youverse, we believe in the importance of securing our products and 
          services and we appreciate the efforts and transparency of the security 
          research community in reporting us vulnerabilities that may have slipped 
          past us during the security testing activities of development and testing 
          stages. Should you find a vulnerability in one of our systems, we would 
          prefer to hear about it as soon as possible so that we can take measures 
          to protect our customers and staff.<br />
        </p>

        <p>
          We may need to update this document from time to time,
          so we recommend you check back periodically. If we make any
          substantial changes, we may notify you via email or by posting a
          notice on our website.
        </p>

        <h2>Definitions</h2>

        <p>For the purposes of this document:</p>

        <ul>
          <li>
            <strong>Company</strong> (referred in this document as either
            “<strong>we</strong>“, “<strong>us</strong>“, “<strong>our</strong>”
            or “<strong>Youverse</strong>”) refers to YOONIK – AUTHENTICATION
            AND PRIVACY SYSTEMS, S.A..
          </li>
          <li>
            <strong>Services</strong> refer to the websites, mobile
            applications, software development kits and other products and
            services that have linked to these document offered by YOONIK –
            AUTHENTICATION AND PRIVACY SYSTEMS, S.A..
          </li>
        </ul>

        <h2>
          Rules of Engagement (RoE)
        </h2>

        <p>
          The RoE we require from you, as a security research/ethical hacker, 
          are the following:
        </p>

        <ul>
          <li>
            Use solely the security@youverse.id channel to report vulnerability 
            information to us;
          </li>
          <li>
            Keep information about any vulnerabilities you’ve discovered 
            confidential between yourself and Youverse;
          </li>
          <li>
            We do not allow authenticated testing and therefore cannot provide 
            credentials;
          </li>
          <li>
            Make every effort to avoid privacy violations, degradation of user 
            experience, disruption to production systems (e.g. deliberate denial 
            of service attacks), and destruction of data during security testing, 
            including avoiding the exploitation of actual vulnerabilities that may 
            directly or indirectly harm Youverse or any interested party.<br />
          </li>
        </ul>
        
        <h2>
          How to report
        </h2>

        <p>
          You can report vulnerabilities via 
          <a href="mailto:security@youverse.id">security@youverse.id</a>. Please 
          always include a description of the vulnerability itself, where exactly 
          did you identify this vulnerability, evidence of the issue (if applicable, 
          screenshots, videos and similar are encouraged), as well as steps explaining 
          how to replicate the vulnerability (we cannot reward nor acknowledge 
          vulnerabilities we cannot verify).
        </p>

        <h2>
          Our commitment
        </h2>

        <p>
          If you follow these guidelines when reporting an issue to us, we commit to:
        </p>

        <ul>
          <li>
            Not pursuing or supporting any legal action related to your research;
          </li>
          <li>
            Working with you to understand and resolve the issue quickly including 
            a) confirming receipt of report within 5 days of submission and 
            b) providing our conclusion on the report within 90 days of the receipt 
            of report;
          </li>
          <li>
            Compensating you appropriately according to the severity of the 
            vulnerability as determined by our internal triage results.
          </li>
          <li>
            To provide compensation we require security researchers/ethical hackers 
            to sign a non-disclosure agreement (NDA), provide a copy of valid 
            identification and produce an invoice for our Portuguese-based headquarters.
          </li>
        </ul>

        <h2>
          Exclusions
        </h2>

        <p>
          This program is not intended for reporting complaints. 
          It is also not intended for:
        </p>

        <ul>
          <li>
            Reporting problems that are already known to us;
          </li>
          <li>
            Reporting that our website or a given service of ours is not available, 
            or DDoS attacks.
          </li>
          <li>
            Reporting error messages that do not contain sensitive information or 
            any error behavior which does not pose a security risk.
          </li>
          <li>
            Reporting phishing emails.
          </li>
          <li>
            Reporting fraud.
          </li>
        </ul>
        
      </div>
    </div>
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");
const textFirstSection = () =>
  import(
    /* webpackChunkName: "textFirstSection" */ "../Components/Layout/textFirstSection.vue"
  );
export default {
  components: { layout, textFirstSection },
};
</script>

<style>
@import "../../css/custom.css";
</style>